// extracted by mini-css-extract-plugin
module.exports = {"rate":"Rate_rate__QSy1j","symbol":"Rate_symbol__jEMaZ","up":"Rate_up__dT0WO","down":"Rate_down__uWen5"};